import {Anchor, Group} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface BackLinkProps {
  label: string;
  onClick: () => void;
}

/** A back-navigation affordance used at the top of signup steps (e.g. "Back", "Back to home"). */
export default function BackLink({label, onClick}: BackLinkProps): JSX.Element {
  return (
    <Anchor aria-label={label} color="dimmed" component="button" size="sm" type="button" onClick={onClick}>
      <Group spacing={4}>
        <BenchlingIcon aria-hidden={true} icon="chevron-left" />
        {label}
      </Group>
    </Anchor>
  );
}
